export enum VariablesType {
  NAME = 'Nombre',
  EMAIL = 'Correo',
  PHONE = 'Teléfono',
  COMPANY = 'Empresa',
  WORKSPACE_NAME = 'WorkspaceName',
}
